const PDF_FILE_EXTENSION = ".pdf";

export const isPdfFile = (fileName?: string): boolean =>
  Boolean(fileName?.toLowerCase().endsWith(PDF_FILE_EXTENSION));
